// GeckoTerminal pool address for $BRACKY / WETH pair on Base
const POOL_ADDRESS = "0x2e8b5cf35680f8b7df0957d05c6a0a4ae1d00cde"
export const BRACKY_CONTRACT_ADDRESS = "0x06f71fb90F84b35302d132322A3C90E4477333b0"

export const GECKO_API_URL = `https://api.geckoterminal.com/api/v2/networks/base/pools/${POOL_ADDRESS}`

export const REFRESH_INTERVAL = 60_000 // 1 minute
export const STALE_TIME = 55_000 // 55 seconds

export interface BrackyPrice {
  priceUsd: number
  change24h: number
  marketCapUsd: number
  /** Number of unique wallets holding $BRACKY */
  holders: number
}
